<template>
  <div class="hos_table">
    <el-form :v-model="getData">
      <el-table
        :model="getData"
        :data="getData"
        style="width: 100%"
        :summary-method="getSummaries"
        show-summary
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          'background-color': '#8FCBFF',
          color: '#333333',
          height: '60px',
        }"
      >
        <el-table-column label="序号" width="100">
          <template slot-scope="scope">
            <div class="positioning">
              <div class="posit_view">
                {{ scope.$index + 1 }}
              </div>
              <p class="botton_view"></p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="StyleName" label="题型">
          <template slot-scope="scope">
            <div class="positioning">
              <div class="posit_view">
                <el-input
                  v-model.trim="scope.row.StyleName"
                  maxlength="10"
                  class="super_input"
                ></el-input>
              </div>
              <!-- <div class="posit_view">{{ scope.row.StyleName }}</div> -->
              <p class="botton_view">{{ scope.row.StyleName }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="StyleName" label="难易度">
          <template>
            <div class="positioning">
              <div class="linear">
                <p>简单</p>
                <p>中等</p>
                <p>困难</p>
              </div>
              <p class="botton_view"></p>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="题数">
          <template slot-scope="scope">
            <div class="positioning">
              <div class="linear">
                <p>{{ scope.row.easyNum }}</p>
                <p>{{ scope.row.mindleNum }}</p>
                <p>{{ scope.row.hardNum }}</p>
              </div>
              <p class="botton_view"></p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="TestCount" label="题量">
          <template slot-scope="scope">
            <div class="positioning">
              <div class="count_view">
                <div>
                  <el-input
                    v-model.trim="scope.row.easyTestcount"
                    :disabled="editState == 'edit'"
                    class="small_input"
                    @change="
                      checkNum(
                        scope.row.easyTestcount,
                        scope.row,
                        'easyTestcount',
                        scope.$index
                      )
                    "
                  ></el-input
                  >题
                </div>
                <div>
                  <el-input
                    v-model.trim="scope.row.mindleTestcount"
                    :disabled="editState == 'edit'"
                    class="small_input"
                    @change="
                      checkNum(
                        scope.row.mindleTestcount,
                        scope.row,
                        'mindleTestcount',
                        scope.$index
                      )
                    "
                  ></el-input
                  >题
                </div>
                <div>
                  <el-input
                    v-model.trim="scope.row.hardTestcount"
                    :disabled="editState == 'edit'"
                    class="small_input"
                    @change="
                      checkNum(
                        scope.row.hardTestcount,
                        scope.row,
                        'hardTestcount',
                        scope.$index
                      )
                    "
                  ></el-input
                  >题
                </div>
              </div>
              <p class="botton_view2">
                <span>{{ subjectNum(scope.row) }}</span> <span>题</span>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="Score" label="分值">
          <template slot-scope="scope">
            <div class="positioning">
              <div class="posit_view">
                <el-input
                  v-model.trim="scope.row.Score"
                  class="small_input"
                  :maxlength="4"
                  :disabled="$parent.$parent.addtopic === 'addEdit'"
                  @change="checkscore(scope.row.Score, scope.$index)"
                ></el-input
                >分
              </div>
              <p class="botton_view2">
                <span>{{ fractionTotal(scope.row) }}</span> <span>分</span>
              </p>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="Explain" label="题型说明" width="430px">
          <template slot-scope="scope">
            <div class="positioning">
              <div class="posit_view">
                <el-input
                  type="textarea"
                  class="long_input"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  v-model.trim="scope.row.Explain"
                  maxlength="200"
                  show-word-limit
                  resize="none"
                >
                </el-input>
              </div>
              <p class="botton_view"></p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <div class="positioning">
              <div class="posit_view">
                <el-button
                  type="text"
                  :class="{ nomove: scope.$index == 0 }"
                  @click="onmoveup(scope.$index, scope.row)"
                  :disabled="scope.$index == 0"
                  >上移</el-button
                >
                <el-button
                  type="text"
                  :class="{ nomove: scope.$index == getData.length - 1 }"
                  @click="onmovedown(scope.$index, scope.row)"
                  :disabled="scope.$index == getData.length - 1"
                  >下移</el-button
                >
                <el-button type="text" @click="deletes(scope.$index)"
                  >删除</el-button
                >
              </div>
              <p class="botton_view"></p>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <!-- 按钮 -->
    <!-- <div class="operation">
      <el-button class="succ_btn" @click="previousstep()">上一步</el-button>
      <el-button type="success" class="submit_btn" @click="nexttothree"
        >下一步</el-button
      >
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      numberamount: 0, // 题数总计
      scoreTotal: 0, // 分数合计
    };
  },
  props: ["getData", "cutcoms", "editState", "testinfomation"],
  computed: {
    // 计算的合计题数
    subjectNum() {
      return function (row) {
        let num =
          Number(row.easyTestcount) +
          Number(row.mindleTestcount) +
          Number(row.hardTestcount);
        return num;
      };
    },
    // 计算合计分数
    fractionTotal() {
      return function (row) {
        let num =
          Number(row.easyTestcount) +
          Number(row.mindleTestcount) +
          Number(row.hardTestcount);
        return num * Number(row.Score);
      };
    },
  },
  methods: {
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 抽题数
    checkNum(row, item, type, index) {
      const regex = /^[0-9]\d*$/;
      if (type === "easyTestcount") {
        // 简单
        if (!regex.test(Number(row)) || row > item.easyNum) {
          this.$message.error("请输入正确的题数且不能大于总数");
          this.getData[index].easyTestcount = 0;
        }
      } else if (type === "mindleTestcount") {
        // 普通
        if (!regex.test(Number(row)) || row > item.mindleNum) {
          this.$message.error("请输入正确的题数且不能大于总数");
          this.getData[index].mindleTestcount = 0;
        }
      } else if (type === "hardTestcount") {
        // 困难
        if (!regex.test(Number(row)) || row > item.hardNum) {
          this.$message.error("请输入正确的题数且不能大于总数");
          this.getData[index].hardTestcount = 0;
        }
      }
      this.amountInput();
    },
    amountInput() {
      this.numberamount = 0;
      this.scoreTotal = 0;
      const newarr = this.getData.map((item) => {
        item.num = 0;
        item.num =
          Number(item.easyTestcount) +
          Number(item.mindleTestcount) +
          Number(item.hardTestcount);
        return item.num;
      });
      for (let i = 0; i < newarr.length; i++) {
        this.numberamount += newarr[i];
      }
      const scopeArr = this.getData.map((item) => {
        return item.num * item.Score;
      });
      for (let i = 0; i < scopeArr.length; i++) {
        this.scoreTotal += scopeArr[i];
      }
    },
    checkscore(row, index) {
      //   var reg = /^[1-9]\d*\.[5]$|0\.[5]$|^[1-9]\d*$/; //可以设置0.5分的
      const reg = /^(?:0|[1-9]\d*)(?:\.\d*[05])?$/;
      if (row == "") {
        this.getData[index].Score = 0;
      }
      if (!reg.test(Number(row))) {
        this.getData[index].Score = 0;
        this.$message.error("请输入0.5的倍数");
      }
      this.amountInput();
    },
    // 合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = []; //循环数组加算的数字
      let value3 = []; //这里是题数的数组
      let value4 = []; //这里是分数的数组
      let reducesum = [];
      let news = [];
      let newstishu = "";
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = "合计";
          return;
        }
        const value = data.map((item) => Number(item[column.property]));
        // console.log(value, "触发了");
        if (index === 4) {
          value3 = JSON.stringify(value);
          value3 = JSON.parse(value3);
          //   console.log("进入题数");
        } else if (index === 5) {
          //   console.log(value3, "进入分数");
          value4 = JSON.stringify(value);
          value4 = JSON.parse(value4);
          reducesum = value3.map((ztiem, zindex) => {
            return ztiem * value4[zindex];
          });
          news = reducesum.reduce((total, num) => {
            return Number(total) + Number(num);
          }, 0);
          newstishu = value4.reduce((totals, nums) => {
            return Number(totals) + Number(nums);
          }, 0);
          console.log(newstishu, "题数", value);
          this.reducesum = news;
          this.$parent.$parent.reducesum = this.scoreTotal;
          // console.log(this.$parent.$parent.reducesum,'总分啊',news,reducesum,newstishu);
          sums[index - 1] = news;
          //   sums[index - 1] += "题";
          sums[index - 1] = this.numberamount + "题";
          sums[index] = newstishu;
          this.reducetishi = newstishu;
          sums[index] = this.scoreTotal + "分";
        }
      });
      //   console.log(sums);
      return sums;
    },
    // 上移
    onmoveup(index, row) {
      var that = this;
      if (index > 0) {
        let upDate = that.getData[index - 1];
        that.getData.splice(index - 1, 1);
        that.getData.splice(index, 0, upDate);
      } else {
        alert("已经是第一条，不可上移");
      }
    },
    onmovedown(index, row) {
      var that = this;
      console.log("下移", index, row);
      if (index + 1 === that.getData.length) {
        alert("已经是最后一条，不可下移");
      } else {
        console.log(index);
        let downDate = that.getData[index + 1];
        that.getData.splice(index + 1, 1);
        that.getData.splice(index, 0, downDate);
      }
    },
    //删除操作
    deletes(index) {
      this.$confirm("确认删除当前题型吗", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.getData.splice(index, 1);
          this.amountInput();
          if (this.getData.length < 1) {
            this.$parent.cutcoms(1);
          }
        })
        .catch(() => {});
    },
    // 上一步
    previousstep() {
      this.$parent.cutcoms(1);
    },
    // 下一步
    nexttothree() {
      let newobj = {};
      let isscore = this.getData.forEach((item) => {
        // item.Score = !item.Score ? 0 : item.Score;
        // item.easyTestcount = !item.easyTestcount ? 0 : item.easyTestcount;
        // item.mindleTestcount = !item.mindleTestcount ? 0 : item.mindleTestcount;
        // item.hardTestcount = !item.hardTestcount ? 0 : item.hardTestcount;
        // 分数不能为0，总题数不能为0 题数为0分数不能填写
        if (item.StyleName === "") {
          this.$message.error("请输入正确的题目名称");
          return false;
        }
        if (newobj[item.StyleName] === undefined) {
          newobj[item.StyleName] = "1";
        } else {
          this.$message.error("请不要输入相同的题型名称");
          isscore = false;
        }
        if (!item.Score || item.Score <= 0) {
          this.$message.error("当前有题型分数为0");
          isscore = false;
        }
      });
      if (this.numberamount <= 0) {
        this.$message.error("当前总题数为0");
      }
      // if (!isscore) {
      //   return;
      // }
      return isscore;
      //   this.$parent.cutcoms(3);
    },
  },
  created() {
    if (this.editState !== "edit") {
      // 编辑模式
      this.numberamount = 0;
      this.scoreTotal = 0;
    }
    this.amountInput();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-table__body-wrapper {
  height: 548px;
  overflow-y: scroll;
}
.hos_table {
  position: relative;
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
.super_input {
  width: 100px !important;
  height: 32px !important;
  font-size: 15px !important;
  > ::v-deep .el-input__inner {
    padding: 0px 8px !important;
    text-align: center;
  }
}
::v-deep .el-table th > .cell {
  align-items: center !important;
  text-align: center;
}
::v-deep td > .cell {
  color: #999999;
  font-size: 15px;
  padding: 0 !important;
  //   padding-left: 0px !important;
  //   padding-right: 0px !important;
}
::v-deep.el-table--enable-row-transition .el-table__body td {
  text-align: center;
}
.el-table__cell {
  padding: 0px !important;
}
.linear {
  // height: 100%;
  height: 210px;
  padding: 16px 0px;
  > p {
    font-size: 18px !important;
    margin-bottom: 54px;
    &:nth-child(3) {
      margin-bottom: 0px;
    }
  }
}
.count_view {
  height: 210px;
  padding: 16px 0px;
  > div {
    margin-bottom: 42px;
    &:nth-child(3) {
      margin-bottom: 0px;
    }
  }
}
.small_input {
  width: 60px !important;
  height: 32px !important;
  font-size: 15px !important;
  margin-right: 10px;
}
// .long_input {
//   width: 420px;
//   height: 100%;
// }
.positioning {
  position: relative;
  width: 100%;
  height: 260px;
  //   border: 1px solid #000;
  padding-left: 0px !important;
  padding-right: 0px !important;
  .posit_view {
    height: 210px;
    display: flex;
    justify-content: center;
    align-items: center;
    // position: absolute;
    // bottom: 0px;
    // left: 50%;
    // width: 100%;
    // height: 40px;
    // background: #f2f2f2;
    // border: 1px solid #000;
    // transform: translate(-50%, -50%);
  }
  .botton_view {
    width: 100%;
    height: 50px;
    line-height: 50px;
    background: #f2f2f2;
    //   border: 1px solid #000;
  }
  .botton_view2 {
    width: 100%;
    height: 50px;
    line-height: 50px;
    background: #f2f2f2;
    span {
      &:nth-child(1) {
        width: 70px;
        display: inline-block;
      }
    }
  }
}
.operation {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 60px 0 100px 0;
  .succ_btn {
    width: 162px;
    height: 50px;
    background: #eeeeee;
    color: #999999;
    margin-right: 90px;
  }
  .submit_btn {
    width: 162px;
    height: 50px;
    background: #0fc758;
    color: #ffffff;
  }
}
</style>